import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // console.log("connect::menu-controller");
  }

  toggle() {
    this.menuTarget.classList.toggle("open");
    this.syncAria();
  }

  syncAria() {
    const open = this.menuTarget.classList.contains("open");
    this.element.querySelectorAll("[data-action*='menu#toggle']").forEach((btn) => {
      btn.setAttribute("aria-expanded", open);
    });
  }

  open() {
    this.menuTarget.classList.add("open");
    this.syncAria();
  }

  close() {
    this.menuTarget.classList.remove("open");
    this.syncAria();
  }
}
